import { ICreditorInvoiceDetailsProps } from "us.collection.economy/interfaces";

export const INITIAL_STATE: ICreditorInvoiceDetailsProps = {
  list: [],
  isListLoading: false,
};
